
import { withCompController } from '@wix/editor-elements-integrations';
import type {
  IWbuSecondaryMediaProps,
  IWbuSecondaryMediaMapperProps,
  IWbuSecondaryMediaControllerProps,
  IWbuSecondaryMediaStateValues,
} from '../../../components/WbuSecondaryMedia/WbuSecondaryMedia.props';

export default withCompController<
  IWbuSecondaryMediaMapperProps,
  IWbuSecondaryMediaControllerProps,
  IWbuSecondaryMediaProps,
  IWbuSecondaryMediaStateValues
>(({ mapperProps, controllerUtils, stateValues }) => {
  const { editorType } = stateValues
  return {
    ...mapperProps,
    editorType,
    updateComponentPropsInViewer: props => {
      controllerUtils.updateProps(props);
    }
  }
});
